export enum EventContainerAndEventOrchestrationWorkspaceCapabilityAccessOperation {
    read = "8b897669-98bb-4077-a3ba-33a9210a5b6e",
}
